import { render, staticRenderFns } from "./HomePageBR.vue?vue&type=template&id=f24dbfb6&scoped=true"
import script from "./HomePageBR.vue?vue&type=script&lang=js"
export * from "./HomePageBR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24dbfb6",
  null
  
)

export default component.exports